import { createBrowserHistory } from "history";

export const QHistory = createBrowserHistory();